import React from 'react'
import AnalyticHero from './analyticHero/AnalyticHero'
import AnalyticsConsult from './analyticsConsult/AnalyticsConsult'
import AnalyticsTestimonial from './analyticsTestimonial/AnalyticsTestimonial'
import AnalyticsService from './analyticsService/AnalyticsService'
import AnalyticSecure from './analyticSecure/AnalyticSecure'
import AnalyticsCases from './analyticsCases/AnalyticsCases'
import AnalyticsApproach from './analyticsApproach/AnalyticsApproach'
import AnalyticsChoose from './analyticsChoose/AnalyticsChoose'
import AnalyticsReady from './analyticsReady/AnalyticsReady'
import AnalyticsFaster from './analyticsFaster/AnalyticsFaster'

export default function Analytics() {
  return (
    <div>
        <AnalyticHero/>
        <AnalyticsConsult/>
        <AnalyticsFaster/>
        <AnalyticsReady/>
        <AnalyticsChoose/>
        <AnalyticsApproach/>
        <AnalyticsCases/>
        <AnalyticSecure/>
        <AnalyticsTestimonial/>
        <AnalyticsService/>
    </div>
  )
}
